import type { IconNode } from '../types';

/**
 * @name candle-tealight-lit
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnMtMiAxLjktMiAzIC45IDIgMiAyIDItLjkgMi0yLTItMy0yLTMiIC8+CiAgPHBhdGggZD0iTTEyIDEyVjciIC8+CiAgPGVsbGlwc2UgY3g9IjEyIiBjeT0iMTMiIHJ4PSIxMCIgcnk9IjMiIC8+CiAgPHBhdGggZD0iTTIgMTN2NmMwIDEuNyA0LjUgMyAxMCAzczEwLTEuMyAxMC0zdi02IiAvPgogIDxwYXRoIGQ9Ik04IDE2djEiIC8+CiAgPHBhdGggZD0iTTEyIDE2djIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/candle-tealight-lit
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const candleTealightLit: IconNode = [
  ['path', { d: 'M12 2s-2 1.9-2 3 .9 2 2 2 2-.9 2-2-2-3-2-3', key: 'n2h0sg' }],
  ['path', { d: 'M12 12V7', key: '1tf3mz' }],
  ['ellipse', { cx: '12', cy: '13', rx: '10', ry: '3', key: '1u2m43' }],
  ['path', { d: 'M2 13v6c0 1.7 4.5 3 10 3s10-1.3 10-3v-6', key: 'ac4evn' }],
  ['path', { d: 'M8 16v1', key: 'n0zjwv' }],
  ['path', { d: 'M12 16v2', key: 'z66u1j' }],
];

export default candleTealightLit;
